import { TRootState }                                   from 'Redux/Reducers';
import { filterObjectStore, queryFilter, IFilterProps } from 'Utils';
import { Employee }                                      from 'Domain/Models';

export const getEmployees = (state: TRootState, filter: null | IFilterProps<Employee> = null) => {
  if (filter === null) {
    filter = queryFilter({ sorting: { by: 'id', order: 'ASC' } }) as IFilterProps<Employee>;
  }

  return filterObjectStore(state.employee.entries, filter);
};
